export default __webpack_public_path__ + "static/media/4-3.ca78310f.webp";